import { fetchForgeContextToken } from 'rest/forge-context-token';
import { ContextTokenCache } from '../context-token-cache';
import { type ExtensionData, type Extension, type ContextTokenData, ContextTokenType } from '../types';

export async function fetchFCTOld(extension: Extension, extensionData: ExtensionData) {
    const key = JSON.stringify({ id: extension.id, data: extensionData });
    const tokenData = ContextTokenCache.getInstance().getValue(key);

    if (!tokenData || (tokenData.expiresAt && Date.now() > tokenData.expiresAt)) {
        const contextData = await makeFetchCall(key, extension, extensionData, ContextTokenCache.getInstance());
        return contextData.token;
    }

    return tokenData.token;
}

const makeFetchCall = async (
    key: string,
    extension: Extension,
    extensionData: ExtensionData,
    contextTokenCache: ContextTokenCache
): Promise<ContextTokenData> =>
    fetchForgeContextToken({ extension, extensionData }).then((value) => {
        contextTokenCache.setValue(key, value);
        return value;
    });

export async function fetchFCTNew(
    extension: Extension,
    extensionData: ExtensionData,
    contextTokenType = ContextTokenType.JSM
) {
    const key = JSON.stringify({ contextTokenType, id: extension.id, data: extensionData });
    const tokenCache = ContextTokenCache.getInstance();
    const tokenData = tokenCache.getValue(key);

    if (!tokenData || (tokenData.expiresAt && Date.now() > tokenData.expiresAt)) {
        const contextData = await fetchForgeContextToken({ extension, extensionData, contextTokenType });
        tokenCache.setValue(key, contextData);
        return contextData.token;
    }

    return tokenData.token;
}
